/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Hazards-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 2/22/18
 * Copyright All Rights Reserved
 */
// @flow

import React from 'react';
import { Col, Row, Nav, NavItem } from 'reactstrap';
import Footer from 'components/support/layout/Footer';
import Header from 'components/support/layout/Header';
import Main from 'components/support/layout/MainContainer';
import Page from 'components/support/layout/Page';
import Map from 'components/support/maps/Map';
import Sidebar from 'components/support/layout/Sidebar/Sidebar';
import SidebarComplement from 'components/support/layout/Sidebar/SidebarComplement';
import SidebarNavLink from 'components/support/layout/Sidebar/SidebarNavLink';

type Props = {
  match: {
    params: {
      scenario: string,
      inventory: string,
    },
    url: string,
  },
};

const PublicPage = (props: Props) => {
  const { match } = props;
  const { scenario, inventory } = match.params;
  return (
    <Page>
      <Header inApp={false} />
      <Main>
        <Row>
          <Sidebar>
            <h5 className="pt-1 mb-1">SF Tall Buildings - Existing</h5>
            <Nav>
              <NavItem key="1">
                <SidebarNavLink to="/map/tallBuilding/calveras">Calaveras M7.0 (mean 0.1g)</SidebarNavLink>
                <SidebarNavLink to="/map/tallBuilding/hayward">Hayward M7.0 (mean 0.2g)</SidebarNavLink>
                <SidebarNavLink to="/map/tallBuilding/sanAndreasP40">San Andreas M8.0 (mean 0.4g)</SidebarNavLink>
                <SidebarNavLink to="/map/tallBuilding/sanAndreasP75">San Andreas M8.0 (high 0.75g)</SidebarNavLink>
              </NavItem>
            </Nav>
            <h5 className="pt-2 mb-1">SF Concrete - Existing Non-Ductile</h5>
            <Nav vertical>
              <NavItem key="2">
                <SidebarNavLink to="/map/concrete/calveras">Calaveras M7.0 (mean 0.1g)</SidebarNavLink>
                <SidebarNavLink to="/map/concrete/hayward">Hayward M7.0 (mean 0.2g)</SidebarNavLink>
                <SidebarNavLink to="/map/concrete/sanAndreasP40">San Andreas M8.0 (mean 0.4g)</SidebarNavLink>
                <SidebarNavLink to="/map/concrete/sanAndreasP75">San Andreas M8.0 (high 0.75g)</SidebarNavLink>
              </NavItem>
            </Nav>
            <h5 className="pt-2 mb-1">SF Tall Buildings – New Code</h5>
            <Nav>
              <NavItem key="3">
                <SidebarNavLink to="/map/tallBuildingNewCode/calveras">Calaveras M7.0 (mean 0.1g)</SidebarNavLink>
                <SidebarNavLink to="/map/tallBuildingNewCode/hayward">Hayward M7.0 (mean 0.2g)</SidebarNavLink>
                <SidebarNavLink to="/map/tallBuildingNewCode/sanAndreasP40">San Andreas M8.0 (mean 0.4g)</SidebarNavLink>
                <SidebarNavLink to="/map/tallBuildingNewCode/sanAndreasP75">San Andreas M8.0 (high 0.75g)</SidebarNavLink>
              </NavItem>
            </Nav>
            <h5 className="pt-2 mb-1">SF Tall Buildings – New Risk Cat IV</h5>
            <Nav>
              <NavItem key="4">
                <SidebarNavLink to="/map/tallBuildingCatIV/calveras">Calaveras M7.0 (mean 0.1g)</SidebarNavLink>
                <SidebarNavLink to="/map/tallBuildingCatIV/hayward">Hayward M7.0 (mean 0.2g)</SidebarNavLink>
                <SidebarNavLink to="/map/tallBuildingCatIV/sanAndreasP40">San Andreas M8.0 (mean 0.4g)</SidebarNavLink>
                <SidebarNavLink to="/map/tallBuildingCatIV/sanAndreasP75">San Andreas M8.0 (high 0.75g)</SidebarNavLink>
              </NavItem>
            </Nav>
            <h5 className="pt-2 mb-1">SF Tall Buildings – New Resilient Design</h5>
            <Nav>
              <NavItem key="5">
                <SidebarNavLink to="/map/tallBuildingResilient/calveras">Calaveras M7.0 (mean 0.1g)</SidebarNavLink>
                <SidebarNavLink to="/map/tallBuildingResilient/hayward">Hayward M7.0 (mean 0.2g)</SidebarNavLink>
                <SidebarNavLink to="/map/tallBuildingResilient/sanAndreasP40">San Andreas M8.0 (mean 0.4g)</SidebarNavLink>
                <SidebarNavLink to="/map/tallBuildingResilient/sanAndreasP75">San Andreas M8.0 (high 0.75g)</SidebarNavLink>
              </NavItem>
            </Nav>

          </Sidebar>
          <SidebarComplement>
            <Row>
              <Col sm="12" className="col">
                { scenario && inventory && (
                  <Map
                    center={{ lat: 37.78747363521412, lng: -122.3944771387952 }}
                    wrapperHeight="600px"
                    zoom={14}
                    scenario={scenario}
                    inventory={inventory}
                    mapTypeId="satellite"
                  />
                )}
              </Col>
            </Row>
          </SidebarComplement>
        </Row>
      </Main>
      <Footer />
    </Page>
  );
}

export default PublicPage;



// WEBPACK FOOTER //
// ./js/components/PublicPage/index.jsx